"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var Yup = _interopRequireWildcard(require("yup"));
var _i18next = _interopRequireDefault(require("i18next"));
var _formik = require("formik");
var _reactI18next = require("react-i18next");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _SetPassword = require("../../../../components/SignUp/SetPassword");
var _Input = require("../../../../components/Input");
var _Button = _interopRequireDefault(require("../../../../components/Button"));
var _FormLabel = _interopRequireDefault(require("../../../../components/FormLabel"));
var _FormErrorMessage = _interopRequireDefault(require("../../../../components/FormErrorMessage"));
var _CreatePasswordFields = _interopRequireDefault(require("../../../../components/CreatePasswordFields"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var validationSchema = Yup.object().shape({
  currentPassword: Yup.string().required('Required'),
  newPassword: Yup.string().matches(_SetPassword.PASSWORD_REGEX, _i18next["default"].t('signup.form.password.invalidCharacters')).min(6, _i18next["default"].t('signup.form.password.length')).max(128, _i18next["default"].t('signup.form.password.length')).notOneOf([Yup.ref('currentPassword'), null], 'Should be different with current password').required('Required'),
  confirmPassword: Yup.string().required('Required').oneOf([Yup.ref('newPassword'), null], 'Password must match')
});
var ChangePassword = function ChangePassword(_ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _onSubmit = _ref.onSubmit;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-full w-full flex items-center justify-center"
    }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null));
  }
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    },
    onSubmit: function onSubmit(values, formikBag) {
      _onSubmit(values.currentPassword, values.newPassword);
    },
    validationSchema: validationSchema
  }, function (_ref2) {
    var errors = _ref2.errors,
      touched = _ref2.touched,
      isValid = _ref2.isValid,
      values = _ref2.values;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col bg-card"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: "currentPassword"
    }, t('settings.recovery.password.form.currentPassword.label')), /*#__PURE__*/_react["default"].createElement(_Input.PasswordInput, {
      autoFocus: true,
      visibleToggle: true,
      size: "lg",
      tabIndex: "1",
      name: "currentPassword",
      placeholder: "Password",
      className: "font-bold text-dark"
    }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
      name: "currentPassword"
    }), /*#__PURE__*/_react["default"].createElement(_CreatePasswordFields["default"], {
      visibleToggle: true,
      autoFocus: false,
      passwordFieldName: "newPassword",
      newPassword: true
    }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      size: "lg",
      disabled: !isValid
    }, "Update password")));
  });
};
var _default = exports["default"] = ChangePassword;
//# sourceMappingURL=SetPassword.js.map